import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PriceComparatorForm from '../../components/PriceComparator/PriceComparatorForm';
import PriceComparatorTable from '../../components/PriceComparator/PriceComparatorTable';
import VideoComponent from '../../core/Video/VideoAnimation';
import InitialAnimationPriceComparator from '../../components/PriceComparator/InitialAnimationPriceComparator';
import TransitionAnimation from '../../components/PriceComparator/TransitionAnimation';
import './price-comparator.css';
import CustomToolTip from '../../core/CustomToolTip/CustomToolTip';
import ModalLegal from '../../components/PriceComparator/ModalLegal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { IconPro } from '../../components/Icons';
import { SuscripcionesPlanes } from '../../components/SuscripcionesPlanes/SuscripcionesPlanes';
import PopUp from '../../shared/PopUp/PopUp';
import Login from '../../components/Login/Login';
import { ProductChildViewModel } from '../../api/models/productChildViewModel';
import { useAuth } from '../../context/AuthContext';
import CircularLoading from '../../shared/CircularLoading/CircularLoading';
import { postApiSubscriptionProducts, ProductViewModelCollectionResult } from '../../api';
import Header from '../../components/Header/Header';
import { IconHelp } from '../../components/Icons/IconHelp';
import ModalComparador from '../../components/PriceComparator/ModalComparador';

const PriceComparatorPageBasic: React.FC = () => {
	const { t } = useTranslation();
	const { state } = useAuth();
	const [showPriceComparatorFrm, setShowPriceComparatorFrm] = useState(true);
	const [showinitialFrm, setinitialFrm] = useState(true);
	const [showVideoComponent, setShowVideoComponent] = useState(false);
	const [fullScreen, setFullScreen] = useState(false);
	const [showPriceComparatorAfterDelay, setShowPriceComparatorAfterDelay] = useState(false);
	const [open, setOpen] = useState(false);
	const [showLoginPopup, setShowLoginPopup] = useState(false);
	const [isOpenPlans, setIsOpenPlans] = useState(false);
	const [childProducts, setChildProducts] = useState<ProductChildViewModel[]>([]);
	const [loadingProducts, setLoadingProducts] = useState<boolean>(true);
	const [productIdsUses, setProductIdsUses] = useState<number[]>([]);
	const [handleRefetchPacks, setHandleRefetchPacks] = useState<() => void>(() => {});
	const [isModalComparadorOpen, setIsModalComparadorOpen] = useState(false);
	const handleComponentChange = () => {
		setShowPriceComparatorFrm(!setShowPriceComparatorFrm);
	};

	const handleStartButtonClick = () => {
		setShowVideoComponent(true);
	};

	const handleOpenPlans = () => {
		setIsOpenPlans(true);
	};

	const handleClosePlans = () => {
		setIsOpenPlans(false);
	};

	// Cargar todos los productos disponibles
	useEffect(() => {
		if (!state?.isAuthenticated) {
			setLoadingProducts(false);
			return;
		}

		const loadProducts = async () => {
			try {
				setLoadingProducts(true);
				const data: ProductViewModelCollectionResult = await postApiSubscriptionProducts();
				if (data.results) {
					// Encontrar el producto "Price Comparator"
					const priceComparatorProduct = data.results.find((product) => product.name === 'Price Comparator');
					if (priceComparatorProduct?.childProducts) {
						setChildProducts(priceComparatorProduct.childProducts);
					}
				}
			} catch (error) {
				console.error('Error al cargar los productos:', error);
			} finally {
				setLoadingProducts(false);
			}
		};

		loadProducts();
	}, [state?.isAuthenticated]);

	const handleFullScreenChange = () => {
		setFullScreen(true);
		setinitialFrm(false);
		setShowPriceComparatorFrm(false);
	};

	let timer: NodeJS.Timeout | null = null;

	useEffect(() => {
		if (fullScreen) {
			timer = setTimeout(() => {
				setShowPriceComparatorAfterDelay(true);
			}, 34000);
		}

		return () => {
			if (timer) {
				clearTimeout(timer);
			}
		};
	}, [fullScreen]);
	const skipIntro = () => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
		if (timer) {
			clearTimeout(timer); // Limpia el timeout si aún está activo
		}
		setShowPriceComparatorAfterDelay(true); // Muestra el contenido inmediatamente
	};

	const handleClickOpen = () => {
		setOpen(true);
	};
	const handleClose = () => {
		setOpen(false);
	};
	if (loadingProducts) {
		return <CircularLoading />;
	}

	return (
		<>
			<Header>
				{showinitialFrm ? (
					<>
						<div className="exporter-test-information__header">
							<div className="price-calc__principal-title">
								<span>{t('price_comparator.header.title')}</span>
								<CustomToolTip
									title=""
									tooltipText={
										<span>
											{t('price_comparator.header.tooltip')}{' '}
											<button
												onClick={handleClickOpen}
												className="price-calc__tootip-link">
												{t('price_comparator.header.button')}
											</button>
										</span>
									}>
									<FontAwesomeIcon
										icon={faCircleInfo}
										className="font-size: 20px"
									/>
								</CustomToolTip>

								<span className="price-calc__tag">{t('price_comparator.header.label')}</span>
							</div>
							<div className="exporter-test-information__principal-sub-title">
								<p>{t('price_comparator.header.subtitle')}</p>
							</div>
						</div>
					</>
				) : null}
			</Header>
			<div className="exporter-test-information__container">
				{showinitialFrm ? (
					<>
						<div className="banner-ui__container banner-ui__container--comparator">
							<div className="banner-ui__container__left">
								<div className="banner-ui__container__label">
									<IconPro fill="#1A2228" /> {t('price_comparator.banner_basic.tag')}
								</div>
								<p className="banner-ui__container__text">
									{t('price_comparator.banner_basic.description')}
								<button
									onClick={() => setIsModalComparadorOpen(true)}
									className="banner-ui__link-button">
										{t('price_comparator.banner_basic.why_pro')}
										<IconHelp />
									</button>
								</p>
							</div>
							<div className="banner-ui__container__right">
								<button
									onClick={() => {
										if (!state?.isAuthenticated) {
											setShowLoginPopup(true);
										} else {
											handleOpenPlans();
										}
									}}
									className="banner-ui__container__button">
									{t('price_comparator.banner_basic.button')}
								</button>
							</div>
						</div>
					</>
				) : null}
				{fullScreen ? (
					<div className="exporter-test__row">
						<div className="col-12">
							{showPriceComparatorAfterDelay ? (
								<PriceComparatorTable />
							) : (
								<>
									<TransitionAnimation />
									<button
										className="exporter-test__skip-intro"
										onClick={skipIntro}>
										{t('price_comparator.step_1.button_skip')}
									</button>
								</>
							)}
						</div>
					</div>
				) : (
					<div className="exporter-test__row">
						<div className="exporter-test__flex">
							{showPriceComparatorFrm ? (
								<PriceComparatorForm
									handleClickOpen={handleClickOpen}
									onComponentChange={handleComponentChange}
									onFullScreenChange={handleFullScreenChange}
								/>
							) : null}
						</div>
						<div className="exporter-test__fixed exporter-test-information__col-4">
							{showVideoComponent ? (
								<VideoComponent
									showSrcImage={true}
									urlImagen={null}
								/>
							) : (
								<InitialAnimationPriceComparator onStartButtonClick={handleStartButtonClick} />
							)}
						</div>
					</div>
				)}
			</div>

			<ModalLegal
				open={open}
				handleClose={handleClose}
			/>

			<ModalComparador
				isOpen={isModalComparadorOpen}
				onClose={() => setIsModalComparadorOpen(false)}
				onViewPacks={() => {
					setIsModalComparadorOpen(false);
					if (!state?.isAuthenticated) {
						setShowLoginPopup(true);
					} else {
						handleOpenPlans();
					}
				}}
			/>

			{state?.isAuthenticated && (
				<SuscripcionesPlanes
					isOpen={isOpenPlans}
					setIsOpen={setIsOpenPlans}
					onClose={handleClosePlans}
					data={childProducts}
					productIdsUses={productIdsUses}
					refetch={handleRefetchPacks}
					productParentName="Price Comparator"
					onBackToPopup={() => {
						setIsOpenPlans(false);
						setIsModalComparadorOpen(true);
					}}
				/>
			)}

			{showLoginPopup && (
				<PopUp
					classes="popup-login"
					onClose={() => setShowLoginPopup(false)}
					isOpen={showLoginPopup}>
					<Login
						onLoginSuccess={() => {
							setShowLoginPopup(false);
						}}
					/>
				</PopUp>
			)}
		</>
	);
};

export default PriceComparatorPageBasic;
